import { render, staticRenderFns } from "./QuestionsAnswersList.vue?vue&type=template&id=5646df57&scoped=true&"
import script from "./QuestionsAnswersList.vue?vue&type=script&lang=js&"
export * from "./QuestionsAnswersList.vue?vue&type=script&lang=js&"
import style0 from "./QuestionsAnswersList.vue?vue&type=style&index=0&id=5646df57&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5646df57",
  null
  
)

export default component.exports